import { RemoveSupplyFormValues } from "./types";

// Initial values
export const initialValues: RemoveSupplyFormValues = {
  requestingCompany: null,
  energyType: "electricity",
  nmi: "",
  mirn: "",
  premise: null,
  noCompany: false,
  abolishmentDate: null,
  abolishmentForm: [],

  supplyServiceOrderNumber: null,
  networkFormNumber: null,
  requesterName: null,
  requesterEmail: null,
  channel: null,
  accountHolderRequest: null,
};
